import React from 'react';
import css from './ErrorModalTitle.less';
import { ExclamationCircleFilled } from '@ant-design/icons';
const ErrorModalTitle = (props) => {
  const { children } = props;

  return (
    <span>
      <ExclamationCircleFilled className={css.errIcon} />
      {children}
    </span>
  );
};
export default ErrorModalTitle;
